// Currency formatting for Indonesian Rupiah
export const formatRupiah = (amount) => {
  if (amount === null || amount === undefined) return 'Rp 0';
  
  // Format with Indonesian locale
  const formatted = new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
  
  return `Rp ${formatted}`;
};

// Short format for large numbers (e.g., Rp 850M)
export const formatRupiahShort = (amount) => {
  if (amount === null || amount === undefined) return 'Rp 0';
  
  if (amount >= 1000000000) {
    return `Rp ${(amount / 1000000000).toFixed(1)}B`;
  }
  if (amount >= 1000000) {
    return `Rp ${(amount / 1000000).toFixed(0)}M`;
  }
  if (amount >= 1000) {
    return `Rp ${(amount / 1000).toFixed(0)}K`;
  }
  return `Rp ${amount}`;
};

// Date formatting
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
};

// Format percentage
export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return '0%';
  return `${Number(value).toFixed(decimals)}%`;
};

// Format change indicator
export const formatChange = (value) => {
  if (value === null || value === undefined) return '';
  const prefix = value >= 0 ? '+' : '';
  return `${prefix}${value}%`;
};

// Generate initials from name
export const getInitials = (name) => {
  if (!name) return '??';
  return name
    .split(' ')
    .slice(0, 2)
    .map(n => n[0])
    .join('')
    .toUpperCase();
};

// Generate WhatsApp link with pre-filled message
export const generateWhatsAppLink = (phone, message) => {
  const cleanPhone = phone?.replace(/[^0-9]/g, '') || '';
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
};

// Generate payment reminder message
export const generatePaymentReminder = (tenantName, amount, dueDate, unitName) => {
  return `Hello ${tenantName},\n\nThis is a friendly reminder that your rent payment of ${formatRupiah(amount)} for ${unitName} is due on ${dueDate}.\n\nPlease ensure timely payment to avoid any late fees.\n\nThank you,\nIntive Property Management`;
};
